function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import moment from 'moment';
import { CandidateBillCyclesSelector } from '../../../../../reducers/selectors/customer.billcycle.selectors';
import { SCHEDULED_ORDER_OPTIONS } from '../../../../../customercare.constants';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { setExecutionOptions, updateFdoExecutionDate } from '../../../../../reducers/actions/order.details.actions';
import { GetMaxDateForFutureDatedOrder, IsFutureDatedOrderAllowedInBunt } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
var ChangeFdoDateModalComponent = /*#__PURE__*/function () {
  function ChangeFdoDateModalComponent($ngRedux) {
    _classCallCheck(this, ChangeFdoDateModalComponent);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      executionOptionsMinDate: moment(new Date()).startOf('day').utc().toISOString(),
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      SCHEDULED_ORDER_OPTIONS: SCHEDULED_ORDER_OPTIONS
    });
    this.executionOptionsModel = this.defaultExecutionOptions;
  }
  return _createClass(ChangeFdoDateModalComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        setExecutionOptions: setExecutionOptions,
        updateFdoExecutionDate: updateFdoExecutionDate
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          candidateBillCycles: CandidateBillCyclesSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfiguration: MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoConfigurationLoaded: MetadataCodeLoadedSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoMaxDate: GetMaxDateForFutureDatedOrder(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.setDefaultBillCycle();
      if (!this.state.fdoConfigurationLoaded) {
        this.actions.fetchCodeTypes(CODES.FutureDatedOrderConfiguration);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "close",
    value: function close() {
      this.actions.setExecutionOptions({});
      this.onClose()();
    }
  }, {
    key: "setDefaultBillCycle",
    value: function setDefaultBillCycle() {
      this.selectedBillCycle = this.state.candidateBillCycles[0];
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(executionOptionsModel) {
      this.actions.setExecutionOptions(executionOptionsModel);
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
    }
  }, {
    key: "submit",
    value: function submit() {
      this.changeFdoForm.$submitted = true;
      if (!this.errorsExistOnForm) {
        this.onSuccess()();
      }
    }
  }]);
}();
export default {
  controller: ChangeFdoDateModalComponent,
  controllerAs: 'ChangeFdoDateModalController',
  template: require('./change.fdo.date.modal.html'),
  bindings: {
    billingEffectiveDateOptions: '<?',
    billingEffectiveDateSettings: '<?',
    contentTitle: '<',
    dialogTitle: '<',
    executionOptions: '<',
    isBillingEffectiveDateShown: '<?',
    onClose: '&',
    onSuccess: '&'
  }
};